import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { UserNamePipeModule } from '@wilson/account';
import {
  User,
  UserQualificationV2,
  UserQualificationV2WithRelation,
} from '@wilson/interfaces';
import {
  LocalizedDateFormatPipe,
  LocalizedDateTimeFormatPipe,
} from '@wilson/localization';
import {
  QualificationNameSyncPipe,
  UserQualificationV2TransformValidTillPipe,
} from '@wilson/qualification-v2/common';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { DateFnsModule } from 'ngx-date-fns';
import { SharedUserQualificationDetailViewResponse } from '../../../../../gateways/shared-user-qualifications-v2.gateway';

@Component({
  selector: 'wilson-user-qualification-v2-details-general-section',
  imports: [
    CommonModule,
    NzCollapseModule,
    QualificationNameSyncPipe,
    TranslatePipe,
    UserNamePipeModule,
    UserQualificationV2TransformValidTillPipe,
    LocalizedDateFormatPipe,
    LocalizedDateTimeFormatPipe,
    DateFnsModule,
  ],
  templateUrl: './user-qualification-v2-details-general-section.component.html',
  styleUrl: './user-qualification-v2-details-general-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserQualificationV2DetailsGeneralSectionComponent {
  @Input() employee!: Pick<User, 'firstName' | 'lastName'> | null;
  private _qualificationDetails!:
    | UserQualificationV2WithRelation
    | SharedUserQualificationDetailViewResponse;
  @Input() set qualificationDetails(
    newQualiDetails:
      | UserQualificationV2WithRelation
      | SharedUserQualificationDetailViewResponse,
  ) {
    this._qualificationDetails = newQualiDetails;
    this.setPartnerName();
    this.setLastEditData();
  }
  get qualificationDetails():
    | UserQualificationV2WithRelation
    | SharedUserQualificationDetailViewResponse {
    return this._qualificationDetails;
  }

  public sharedQualiPartnerName: string | undefined;
  public qualiLastEdited:
    | Pick<
        UserQualificationV2,
        'createdAt' | 'createdById' | 'updatedAt' | 'updatedById'
      >
    | undefined;

  private setPartnerName() {
    if ('partnerName' in this.qualificationDetails) {
      this.sharedQualiPartnerName = this.qualificationDetails.partnerName;
    } else {
      this.sharedQualiPartnerName = undefined;
    }
  }

  private setLastEditData() {
    if (
      'createdAt' in this.qualificationDetails &&
      'createdById' in this.qualificationDetails &&
      'updatedAt' in this.qualificationDetails &&
      'updatedById' in this.qualificationDetails
    ) {
      this.qualiLastEdited = {
        createdAt: this.qualificationDetails.createdAt,
        createdById: this.qualificationDetails.createdById,
        updatedAt: this.qualificationDetails.updatedAt,
        updatedById: this.qualificationDetails.updatedById,
      };
    } else {
      this.qualiLastEdited = undefined;
    }
  }
}
